<template>
  <donut-chart08-template
    :board-ids="[239]"
    :data-type="dataType"
    field-code="facility"
    :graph-id="57"
    title="(시설물) 비상대피 훈련 현황"
    unit="건"/>
</template>

<script>
/* eslint-disable brace-style */
import DonutChart08Template from "@/views/graph/DonutChart08Template.vue";

export default {
  name: 'DonutChart57',
  components: {DonutChart08Template},
  props: {
    dataType: 'detail' | 'field' | 'company' | 'project',
  },
}
</script>

<style scoped>

</style>
